import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanSwitchComponent } from './boolean-switch.component';

@NgModule({
    declarations: [BooleanSwitchComponent],
    imports: [
        CommonModule
    ],
    exports: [BooleanSwitchComponent]
})
export class BooleanSwitchModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/boolean-switch/boolean-switch.module.ts